import React from "react";
import { Container } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import styles from "./_css/featuredProperties.module.css";
import FeaturedPropertiesSections from "home/sections/FeaturedPropertiesSections";
import { homeSearchStore } from "home/_stores/homeSearchStore";
import { FEATURED_PROPERTIES_ALL } from "properties/_stores/propertiesStore";
import { PROPERTY_PURPOSE } from "properties/_models/PropertyMdl";
import { URLS } from "_configs/URLS";

export const FeaturedPropertiesHomePage = observer(() => {
    const { t } = useTranslation();
    const seeAllUrl = homeSearchStore.purpose === PROPERTY_PURPOSE.RENT ? URLS.rent() : URLS.buy();
    return (
        <Container className={styles.container}>
            <div className={styles.header}>
                <h2 className={styles.title}>{t("propertyPage.featuresPropertiesHomePage")}</h2>
                <Link to={seeAllUrl} className={styles.seeAll}>
                    <span className={styles.seeAllText}>{t("menu.seeAll")}</span>
                    <svg
                        className={styles.seeAllArrow}
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                    >
                        <path
                            d="M1 7h15M11 2l5 5-5 5"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </Link>
            </div>
            <FeaturedPropertiesSections purpose={"BOTH"} carousel exclusiveOnly limit={FEATURED_PROPERTIES_ALL} />
        </Container>
    );
});
